import {getPersisterStorageKey} from '@github-ui/react-query-persister/storage-key'

export type IssueViewerStorageCoordinates = {owner: string; repo: string; number: number}

export const ISSUE_VIEWER_PERSISTER_PREFIX = 'server-persisted-query'

export function getIssueViewerStorageQueryKey({
  owner,
  repo,
  number,
}: IssueViewerStorageCoordinates): readonly unknown[] {
  return ['issue-viewer', 'primary-view', {number, owner, repo}]
}

export function getIssueViewerPersisterStorageKey(coordinates: IssueViewerStorageCoordinates): string {
  return getPersisterStorageKey({
    prefix: ISSUE_VIEWER_PERSISTER_PREFIX,
    queryKey: getIssueViewerStorageQueryKey(coordinates),
  })
}
